import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { getOneClickJobsites } from '../../selectors/one-click-jobsites.selector';
import { filter, take, map, tap } from 'rxjs/operators';
import { OneClickSelectJobsiteAction, OneClickLoadJobsiteStdLotAction } from '../../actions/one-click-jobsites.actions';
import { OneClickLoadProductsAction, OneClickResetProductsAction } from '../../actions/one-click-products.actions';
import { OneClickBuilderField } from '../../util/constants/builder-fields';

@Injectable()
export class OneClickSyncJobsiteLoadProducts implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.resetDefaults(formGroup);
    this.store
      .pipe(
        select(getOneClickJobsites),
        filter((jobsites) => !!value && !!jobsites.length),
        take(1),
        map((jobsites) => jobsites.find((project) => project.jobsite.jobsiteId === value)),
        tap((jobsite) => {
          this.store.dispatch(new OneClickResetProductsAction());
          jobsite && this.store.dispatch(new OneClickSelectJobsiteAction(jobsite));
        }),
      )
      .subscribe(() => {
        this.store.dispatch(new OneClickLoadProductsAction());
        this.store.dispatch(new OneClickLoadJobsiteStdLotAction());
      });
  }

  private resetDefaults(formGroup: UntypedFormGroup) {
    const fieldsToReset = [
      OneClickBuilderField.Product,
      OneClickBuilderField.Plant,
      OneClickBuilderField.Payment,
      OneClickBuilderField.Unit,
      OneClickBuilderField.StandardLot,
    ];

    fieldsToReset.forEach((field) => formGroup.controls[field] && formGroup.controls[field].setValue(undefined));
  }
}
